import React from 'react';

function PageNotFound() {
  return (
    <div className="page">
      <h1>404 Page Not Found</h1>
    </div>
  );
}

export default PageNotFound;
